import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Developments {
	constructor() {
		this.photos = document.querySelectorAll(".developments__photo-wrap");
	}

	init() {
		this.photos.forEach((wrap) => {
			const photo = wrap.querySelector(".developments__photo");
			if (!photo) return;

			gsap.fromTo(
				photo,
				{ y: 0 },
				{
					y: -60,
					ease: "none",
					scrollTrigger: {
						trigger: wrap,
						start: "top bottom",
						end: "bottom top",
						scrub: 0.8,
					},
				}
			);
		});
	}
}

export default Developments;
